import { defineComponent, reactive, ref } from "vue";

import { hmdConfirm } from "@/dialog/index";

/**
 * 从合同中选择工程量清单
 */
export default defineComponent({
  name: "ContractQuantitySelect",
  props: {
    contractId: {
      type: String,
      required: true,
    },
  },
  emits: ["ok"],
  setup(props, { emit }) {
    const visible = ref(false);
    const showModal = async () => {
      hmdConfirm({
        com: import("./dialog.vue"),
        params: {
          //@ts-ignore
          contractId:props.contractId,
        },
        confirm:({res})=>{
          emit("ok", res.quantities);
        }
      });
    };    
    return {
      visible,
      showModal,
    };
  },
});
